var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "px-0 pt-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-0", attrs: { cols: "12" } },
            [
              (_vm.currentUser.clientType === "Media" ||
                _vm.currentUser.clientType === "Driblab") &&
              !_vm.hideMedia
                ? _c("MediaModeForm", {
                    attrs: {
                      fields: _vm.mediaModeFields,
                      mediaMode: _vm.mediaMode,
                      mediaModeData: _vm.mediaModeData,
                      selectorMode: "",
                    },
                    on: {
                      mediaModeChange: function ($event) {
                        return _vm.onMediaModeChange($event)
                      },
                      mediaModeDataChange: function ($event) {
                        return _vm.onMediaModeDataChange($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.xTText && _vm.phase === 0
            ? _c(
                "v-col",
                { staticClass: "px-4 body-1", attrs: { cols: "12" } },
                [
                  _c("div", {
                    attrs: { id: "gameFlowText" },
                    domProps: { innerHTML: _vm._s(_vm.xTTextCompact) },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            {
              class: _vm.phase > 0 ? "px-0 py-0" : "px-0",
              attrs: {
                cols: "12",
                lg: "5",
                order: _vm.$vuetify.breakpoint.smAndDown ? 2 : 1,
              },
            },
            [
              _vm.phase > 0
                ? _c(
                    "v-col",
                    { staticClass: "py-0 mb-3", attrs: { cols: "12" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "rounded text-center pa-2 pt-3",
                          class: _vm.$vuetify.theme.dark
                            ? "secondary"
                            : "primary",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "white--text header-font",
                              staticStyle: { "font-size": "18px" },
                            },
                            [_vm._v(_vm._s(_vm.phasesHeaderText))]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "py-0", attrs: { cols: "12" } },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      id: "gameFlowTable",
                      headers: _vm.gameFlowDataHeader,
                      items: _vm.gameFlowDataPerPhasesItems,
                      "items-per-page": _vm.itemsPerPage,
                      dense: "",
                      "hide-default-footer": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm._l(_vm.gameFlowDataHeader, function (h, index) {
                          return {
                            key: `header.${h.value}`,
                            fn: function ({ header }) {
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    key: index,
                                    attrs: {
                                      top: "",
                                      color: "lightSecondary lighten-4",
                                      "max-width": "300",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  {
                                                    class: {
                                                      "px-2": index === 0,
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v(_vm._s(h.text))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "black--text body-1" },
                                      [_vm._v(_vm._s(h.tooltip))]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          }
                        }),
                        {
                          key: "item.teamId",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "pl-2 my-2" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "nav-link d-flex align-center w-100",
                                      attrs: { to: "/team/" + item.teamId },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          height: "20px",
                                          width: "20px",
                                        },
                                        attrs: {
                                          src:
                                            "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                            item.teamId +
                                            ".png",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pl-1 body-1",
                                          class: _vm.$vuetify.theme.dark
                                            ? "primary--text"
                                            : "secondary--text text--darken-2",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.teamName) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.period",
                          fn: function ({ item }) {
                            return [
                              item.period > 0
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.minFrom) +
                                        "' - " +
                                        _vm._s(item.minTo) +
                                        "' (" +
                                        _vm._s(item.period) +
                                        ")"
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.minFrom) +
                                        "' - " +
                                        _vm._s(item.minTo) +
                                        "' (1-2)"
                                    ),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "item.possession",
                          fn: function ({ item }) {
                            return [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.toRound(item.possession * 100, 1)
                                    ) +
                                    "%"
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.xT",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-center justify-center font-weight-bold",
                                  class: _vm.getTextColorClass(item, "xT"),
                                  style: {
                                    "background-color": _vm.getBackgroundColor(
                                      item,
                                      "xT"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.toRound(item.xT, 3))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.passesFinalThird",
                          fn: function ({ item }) {
                            return [
                              _c("span", [
                                _vm._v(" " + _vm._s(item.passesFinalThird)),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.xG",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 h-100 d-flex align-center justify-center font-weight-bold",
                                  class: _vm.getTextColorClass(item, "xG"),
                                  style: {
                                    "background-color": _vm.getBackgroundColor(
                                      item,
                                      "xG"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.toRound(item.xG, 2))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.xTText && _vm.phase > 0
                ? _c("v-col", { attrs: { cols: "12" } }, [
                    _c("div", {
                      staticClass: "body-1",
                      staticStyle: { "text-align": "justify" },
                      domProps: { innerHTML: _vm._s(_vm.xTText) },
                    }),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              class: _vm.phase > 0 ? "pl-md-0 pb-5 pt-0" : "pl-md-0",
              attrs: {
                cols: "12",
                lg: "7",
                order: _vm.$vuetify.breakpoint.smAndDown ? 1 : 2,
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-column h-100 py-" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "card-chart h-100 rounded-b-0",
                      attrs: {
                        elevation: "0",
                        outlined: "",
                        dark: _vm.$vuetify.theme.dark,
                      },
                    },
                    [
                      [
                        !_vm.mediaMode
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "d-flex align-center pl-7",
                                    attrs: { cols: "12", xl: "8" },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          color: "secondary",
                                          large: "",
                                        },
                                      },
                                      [_vm._v("stacked_bar_chart")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "primary--text monospace-font body-1 font-weight-medium",
                                          },
                                          [_vm._v(_vm._s(_vm.xTChart.title))]
                                        ),
                                        _vm._v(" "),
                                        _vm.game
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    src:
                                                      "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                      _vm.game.homeTeamId +
                                                      ".png",
                                                    height: 20,
                                                    width: 20,
                                                    contain: "",
                                                  },
                                                  on: {
                                                    error: function ($event) {
                                                      return _vm.onImgError(
                                                        $event,
                                                        _vm.item
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text mx-1 body-2 subheader-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.game.homeTeamName
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-center text--darken-2 body-2 subheader-font",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.game.homeTeamScore
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "mx-1" },
                                                      [_vm._v("-")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.game.awayTeamScore
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text mx-1 body-2 subheader-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.game.awayTeamName
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("v-img", {
                                                  staticClass: "ml-1",
                                                  attrs: {
                                                    src:
                                                      "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                      _vm.game.awayTeamId +
                                                      ".png",
                                                    height: 20,
                                                    width: 20,
                                                    contain: "",
                                                  },
                                                  on: {
                                                    error: function ($event) {
                                                      return _vm.onImgError(
                                                        $event,
                                                        _vm.item
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.game
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-space-between px-6 mt-n1",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text body-2 subheader-font",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.game
                                                            .homeTeamFormation
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "primary--text body-2 subheader-font pr-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.game
                                                            .awayTeamFormation
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      _vm._v(" "),
                      _vm.avatarSize &&
                      _vm.mediaMode &&
                      _vm.xTChart.data.datasets[0].data.length &&
                      _vm.game
                        ? _c("GameAvatarMedia", {
                            ref: "gameAvatarMediaRef",
                            staticClass: "mt-5",
                            attrs: {
                              width: _vm.avatarSize.width,
                              height: _vm.avatarSize.height,
                              id: `${_vm.gameId}-${_vm.chartId}`,
                              game: _vm.game,
                              titleLeft: _vm.mediaModeData.titleLeft,
                              titleRight: _vm.mediaModeData.titleRight,
                              leftColor: _vm.mediaModeData.leftBorderColor,
                              rightColor: _vm.mediaModeData.rightBorderColor,
                              bgColor: _vm.mediaModeData.bgColor,
                              textColor: _vm.mediaModeData.textColor,
                              type: "gameFlow",
                              lineDistance: _vm.mediaModeData.lineLength,
                              avatarSize: _vm.mediaModeData.avatarSize,
                              lineWeight: _vm.mediaModeData.lineWeight,
                              titleFontSize: _vm.mediaModeData.titleFontSize,
                              titleFontWeight:
                                _vm.mediaModeData.titleFontWeight,
                              subtitle: _vm.mediaModeData.subtitle,
                              subtitleFontSize:
                                _vm.mediaModeData.subtitleFontSize,
                              subtitleFontWeight:
                                _vm.mediaModeData.subtitleFontWeight,
                              subtitle2: _vm.mediaModeData.subtitle2,
                              subtitle2FontSize:
                                _vm.mediaModeData.subtitle2FontSize,
                              subtitle2FontWeight:
                                _vm.mediaModeData.subtitle2FontWeight,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.xTChart.data.datasets[0].data.length > 0
                        ? _c("ZeroLineChart", {
                            ref: "xTChartRef",
                            attrs: {
                              datasets: _vm.xTChart.data.datasets,
                              xAxisLabels: _vm.xTChart.data.labels,
                              options: _vm.xTChart.options,
                              mediaMode: _vm.mediaMode,
                              id: `${_vm.id}${_vm.gameId}-${_vm.chartId}`,
                            },
                            on: {
                              sizeChange: function ($event) {
                                return _vm.onChartSizeChange($event)
                              },
                              loaded: function ($event) {
                                return _vm.onLoaded($event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.game &&
                      _vm.avatarSize &&
                      _vm.mediaMode &&
                      _vm.mediaModeData.socialMedia
                        ? _c("DriblabSocialMedia", {
                            ref: "driblabSocialMediaRef",
                            staticClass: "mt-n3",
                            attrs: {
                              width: _vm.avatarSize.width,
                              height: 50,
                              id: `${_vm.gameId}-${_vm.chartId}`,
                              bgColor: _vm.mediaModeData.bgColor,
                              textColor: _vm.mediaModeData.textColor,
                              fontSize: _vm.mediaModeData.socialMediaFontSize,
                              fontWeight:
                                _vm.mediaModeData.socialMediaFontWeight,
                              logoCfg: _vm.mediaModeData.logo,
                              sponsor: _vm.mediaModeData.sponsor.dataUrl,
                              type: "gameFlow",
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.xTChart.data.datasets[0].data.length > 0 && !_vm.hideMedia
                    ? _c(
                        "v-card",
                        {
                          staticClass:
                            "d-flex justify-end py-2 px-0 rounded-t-0",
                          attrs: {
                            elevation: "0",
                            outlined: "",
                            color: "transparent",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsPNG()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("\n                file_download")]
                              ),
                              _vm._v(" "),
                              _c("span", {}, [_vm._v("PNG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.saveAsSVG()
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("file_download"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("SVG")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-3 mx-1",
                              attrs: {
                                color: "secondary",
                                rounded: "",
                                small: "",
                                "x-small": !_vm.$vuetify.breakpoint.xsOnly,
                                loading: _vm.loadingExport,
                                disabled: !_vm.chartSize,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onGenerateIFrameClick()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v("share")]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Embed")]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.game
        ? _c("ChartExportLinksModal", {
            ref: "chartExportLinksModalRef",
            attrs: {
              title: `${_vm.game.homeTeamName} ${_vm.game.homeTeamScore} - ${_vm.game.awayTeamScore} ${_vm.game.awayTeamName}`,
              subtitle: _vm.$t("game.header.gameFlow"),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }